export const GET_USER_DOCUMENTATION_REQUEST = 'GET_USER_DOCUMENTATION_REQUEST';
export const GET_USER_DOCUMENTATION_SUCCESS = 'GET_USER_DOCUMENTATION_SUCCESS';
export const GET_USER_DOCUMENTATION_ERROR = 'GET_USER_DOCUMENTATION_ERROR';
